import { Trans, useTranslation } from "react-i18next";

import { AuthCoverLink, type AuthCover } from "@/components/shared/AuthShell";
import { getSupportMailtoHref } from "@/lib/support";

/**
 * The role-less cover, for the funnel screens that are not about picking a
 * role: password recovery, first-time password setup, email verification.
 * Login drives its own cover instead, because there the copy follows the
 * hovered role card.
 *
 * Shared rather than copied per page so the support link stays wired in ONE
 * place — that note is the only line on these screens offering a way out, and
 * LiveChat is deliberately not loaded on the auth paths, so it goes to mail.
 *
 * It lives outside AuthShell.tsx because a module that exports both components
 * and a hook breaks Fast Refresh (react-refresh/only-export-components).
 */
export function useNeutralAuthCover(): AuthCover {
  const { t } = useTranslation();
  return {
    title: t("auth.login.cover.neutralTitle"),
    body: t("auth.login.cover.neutralBody"),
    note: (
      <Trans
        i18nKey="auth.login.cover.neutralNote"
        components={{ support: <AuthCoverLink href={getSupportMailtoHref()} /> }}
      />
    ),
  };
}
